export default "__VITE_ASSET__c46444a1__"